export default "__VITE_ASSET__D8_Cv48b__"